module.exports = __webpack_public_path__ + "static/media/ehealth_lab_record_banner_mobile.7fa023f4.jpg";